export default __webpack_public_path__ + "static/upscale_back-37d1cb6c3ca99575a648c4538716a767.webp";